const selected=(data)=>{
	if(data)
	return "green"
	
	}
export const downloadColumns =(handleDownlodLinkClick)=> [
    {
		name: 'Serial No',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.srNo}</div>,
		minWidth:"120px",
		center:true,
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"120px",
        },
	},
	{
		name: 'Week No',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.weekNo}</div>,
		center: true,
		minWidth:"120px",
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"120px",
        },
	},
    {
		name: 'Week Start Date',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.startDate}</div>,
        minWidth:"220px",
		center: true,
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"220px",
        },
	},
	{
		name: 'Week End Date',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.endDate}</div>,
        minWidth:"220px",
		center: true,
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"220px",
        },
	},
    {
		name: 'Record Count',
		//selector: row => row.recordCount,
		cell: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.recordCount}</div>,
        minWidth:"120px",
		center: true,
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"120px",
        },
	},
	{
		name: '',
		field:'action',	
		minWidth: "220px",
		align: "center",
		style: {
            justifyContent: "center",
            textAlign:"center",
            minWidth:"220px",
        },
		cell : (row, props) =>  (
			<div className="center-aligned-cell">
				{(row.data == "DATA FOUND") ? <a href="#" onClick={()=>handleDownlodLinkClick(row, props, 'excel')}>Download</a>
				: ""
				}
			</div>)
	},
];
